import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination'

import PRODUCT from '../img/product.jpg'
import MEDIA from '../img/media.jpg'
import MANAGEMNET from '../img/management.jpg'
import PERFORMANCE from '../img/performance.jpg'
import MUSIC from '../img/music.jpg'

function SwiperSection() {  
    return(
        <div>
            <div className='title-animate title'>
                BUSINESS
            </div>
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                mousewheel={true}
                pagination={{ clickable: true }}
                modules={[Mousewheel, Pagination]}
            >
            <SwiperSlide>
                <div className='card-wrapper'>
                    <img src={ PRODUCT } alt=''/>
                    <span className='title'>공연 기획</span>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='card-wrapper'>
                    <img src={ MEDIA } alt=''/>
                    <span className='title'>미디어 컨텐츠</span>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='card-wrapper'>
                    <img src={ MANAGEMNET } alt=''/>
                    <span className='title'>1인 미디어 매니지먼트</span>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='card-wrapper'>
                    <img src={ PERFORMANCE } alt=''/>
                    <span className='title'>퍼포먼스 크리에이티브</span>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='card-wrapper'>
                    <img src={ MUSIC } alt=''/>
                    <span className='title'>뮤직 크리에이티브</span>
                </div>
            </SwiperSlide>
          </Swiper>
        </div>
    );
}

export default SwiperSection;